import { render, staticRenderFns } from "./_CreateAsset.vue?vue&type=template&id=68b6777f"
import script from "./_CreateAsset.vue?vue&type=script&lang=ts"
export * from "./_CreateAsset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports